import { render, staticRenderFns } from "./frozenAmount.vue?vue&type=template&id=dfde9cdc&scoped=true"
import script from "./frozenAmount.vue?vue&type=script&lang=js"
export * from "./frozenAmount.vue?vue&type=script&lang=js"
import style0 from "./frozenAmount.vue?vue&type=style&index=0&id=dfde9cdc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfde9cdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfde9cdc')) {
      api.createRecord('dfde9cdc', component.options)
    } else {
      api.reload('dfde9cdc', component.options)
    }
    module.hot.accept("./frozenAmount.vue?vue&type=template&id=dfde9cdc&scoped=true", function () {
      api.rerender('dfde9cdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/financeManagement/platformDeposit/frozenAmount.vue"
export default component.exports